import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Helmet } from 'react-helmet-async';
import * as React from 'react';
// @mui
import { Container, Stack, Button, Typography, TextField, Autocomplete } from '@mui/material';
// api
import { getProdutos, getMetas, updateMeta, getUsuarios, getGenericData, updateGenericData } from './api';
import { useUnidades } from '../hooks/useUnidades';

const RadioButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-right: 15px;
`;

const RadioButton = styled.input`
  margin-right: 5px;
`;

const BaseLabel = styled.h1`
  font-size: 0.9em;
  color: rgb(100, 100, 100);
  width: 150px;
`;

const RadioLabel = styled.label`
  font-size: 0.9em;
  color: rgb(0, 0, 0);
  font-weight: bold;
  line-height: 10px;
`;

// ----------------------------

// ----------------------------------------------------------------------

export default function Metas() {
  const [metas, setMetas] = useState({});
  const [alteracao, setAlteracao] = useState(false);
  const [tipoMeta, setTipoMeta] = useState('usuario');
  const [metasUnidade, setMetasUnidade] = useState({});

  const [produtos, setProdutos] = useState([
    { _id: '65089a46326edddd6ff36604', nome: 'Proposta Comercial' },
    { _id: '65089a46326edddd6ff36605', nome: 'Seguro' },
    { _id: '65089a46326edddd6ff36606', nome: 'Limpeza' },
  ]);

  const { unidades } = useUnidades();
  // const anos = [2023,2024,2025,2026,2027,2028,2029,2030,2031,2032,2033,2034,2035,2036,2037,2038,2039,2040]

  const [filtro, setFiltro] = useState({});

  const [usuarios, setUsuarios] = useState([]);

  useEffect(() => {
    if (filtro.usuario && filtro.produto) {
      fetchMetas(filtro);
    }
  }, [filtro.usuario, filtro.produto]);

  useEffect(() => {
    const getMetasUnidade = async () => {
      const resultado = await getGenericData('metaunidade', { unidade: filtro.unidade });
      console.log(resultado)
      setMetasUnidade(resultado[0] || {});
    };
    getMetasUnidade();
  }, [filtro.unidade]);

  const fetchMetas = async (filtro) => {
    const result = await getMetas(filtro);
    setMetas(result?.metas || {});
  };

  useEffect(() => {
    fetchUsuarios();
  }, []);
  const fetchUsuarios = async () => {
    const result = await getUsuarios();
    setUsuarios(result);
  };

  useEffect(() => {
    fetchProdutos();
  }, []);
  const fetchProdutos = async () => {
    const resultado = await getProdutos();
    // CORRIGIDO (deployment Marcki — Serviços sumindo da lista de Metas):
    // antes havia um `resultado.splice(3, 1)` aqui, que removia o produto na
    // POSIÇÃO 3 do array — o MongoDB não garante ordem de retorno sem um
    // sort explícito, então essa posição varia entre bancos/instâncias.
    // Na Marcki, "Serviços" calhou de cair na posição 3, sendo removido por
    // engano. O catálogo da Marcki também não tem um produto "Solo"
    // separado (motivo original do splice na Arasol), então a exclusão foi
    // removida — todos os produtos do catálogo aparecem agora.
    setProdutos(resultado);
  };

  const handleChangeMeta1 = (e, index) => {
    let updatedMetas;
    if (metas?.valor) {
      // Se metas.valor já está definido, faça uma cópia e atualize a posição do index.
      const newArray = [...metas.valor];
      newArray[index] = parseFloat(e.target.value);
      updatedMetas = { ...metas, valor: newArray };
    } else {
      // Se metas.valor ainda não está definido, crie um novo array.
      const newArray = Array(12).fill(0); // Array com 12 elementos vazios
      newArray[index] = parseFloat(e.target.value);
      updatedMetas = { ...metas, valor: newArray };
    }
    setMetas(updatedMetas);
    setAlteracao(true);
  };

  const handleChangeMeta2 = (e, index) => {
    let updatedMetas;
    if (metas?.quantidade) {
      const newArray = [...metas.quantidade];
      newArray[index] = parseFloat(e.target.value);
      updatedMetas = { ...metas, quantidade: newArray };
    } else {
      const newArray = Array(12).fill(0); // Array com 12 elementos vazios
      newArray[index] = parseFloat(e.target.value);
      updatedMetas = { ...metas, quantidade: newArray };
    }
    setMetas(updatedMetas);
    setAlteracao(true);
  };

  const handleConfirm = async () => {
    const dados = { usuario: filtro.usuario, produto: filtro.produto, metas };
    const result = await updateMeta(dados);
    window.alert(result.msg);
    setAlteracao(false);
  };

  const handleConfirmUnidade = async () => {
    const dados = {
      unidade: metasUnidade.unidade || filtro.unidade,
      metasVenda: metasUnidade.metasVenda,
      metasRecebimento: metasUnidade.metasRecebimento,
    };
    await updateGenericData('metaunidade', dados);
    setAlteracao(false);
  };

  const handleChangeMetaUnidade = (e, index, metaName) => {
    if (!metasUnidade[metaName]) metasUnidade[metaName] = Array(12).fill(0);

    // Se metas.valor já está definido, faça uma cópia e atualize a posição do index.
    const newArray = [...metasUnidade[metaName]];
    newArray[index] = parseFloat(e.target.value);
    const updatedMetas = { ...metasUnidade, [metaName]: newArray };

    setMetasUnidade(updatedMetas);
    setAlteracao(true);
  };

  // ----------------------

  return (
    <>
      <Helmet>
        <title> Metas </title>
      </Helmet>

      <Container maxWidth="xl">
        <Stack direction={'row'} display={'flex'} justifyContent={'center'} mb={5}>
          <BaseLabel>Tipo Meta</BaseLabel>
          <RadioButtonWrapper>
            <RadioButton
              type="radio"
              name="tipoMeta"
              value="usuario"
              checked={tipoMeta === 'usuario'}
              onChange={() => setTipoMeta('usuario')}
            />
            <RadioLabel>Usuário</RadioLabel>
          </RadioButtonWrapper>
          <RadioButtonWrapper>
            <RadioButton
              type="radio"
              name="tipoMeta"
              value="unidade"
              checked={tipoMeta === 'unidade'}
              onChange={() => setTipoMeta('unidade')}
            />
            <RadioLabel>Unidade</RadioLabel>
          </RadioButtonWrapper>
        </Stack>

        {tipoMeta === 'usuario' && (
          <>
            <Stack direction={'row'} gap={3} justifyContent={'center'}>
              <Autocomplete
                disablePortal
                id="usuario"
                value={filtro.usuario}
                onChange={(event, newValue) => {
                  setFiltro({ ...filtro, usuario: newValue });
                }}
                options={usuarios}
                isOptionEqualToValue={(option, value) => option._id === value._id}
                getOptionLabel={(option) => `${option.nome}`}
                sx={{ width: 400, mb: 2 }}
                renderInput={(params) => <TextField {...params} label="Selecione o Usuário" />}
              />

              <Autocomplete
                disablePortal
                disabled={!JSON.parse(localStorage.getItem('userData'))?.supervisor}
                id="produto"
                value={filtro.produto}
                onChange={(event, newValue) => {
                  setFiltro({ ...filtro, produto: newValue });
                }}
                options={produtos}
                isOptionEqualToValue={(option, value) => option._id === value._id}
                getOptionLabel={(option) => `${option.nome}`}
                sx={{ width: 400, mb: 2 }}
                renderInput={(params) => <TextField {...params} label="Selecione o Produto" />}
              />

              <Button
                disabled={!alteracao}
                variant="contained"
                color="success"
                onClick={handleConfirm}
                sx={{ height: 50 }}
              >
                Salvar
              </Button>
            </Stack>
            {filtro.usuario && filtro.produto && (
              <Stack direction={'row'} justifyContent={'center'} gap={10}>
                <Stack
                  gap={1}
                  justifyContent={'center'}
                  alignItems={'center'}
                  sx={{ border: 1, borderRadius: 2, width: '40%' }}
                >
                  <Typography variant="h5" sx={{ mb: 1 }}>
                    Metas Por Valor
                  </Typography>
                  <Stack gap={1} justifyContent={'center'} alignItems={'center'} mb={2}>
                    {Array.from({ length: 12 }, (_, index) => (
                      <TextField
                        key={index}
                        size="small"
                        id={`meta-${index}`}
                        label={`Mês ${index + 1}`}
                        inputProps={{ type: 'number' }}
                        variant="outlined"
                        value={metas?.valor && metas.valor[index] ? metas.valor[index] : ''}
                        onChange={(e) => handleChangeMeta1(e, index)}
                      />
                    ))}
                  </Stack>
                </Stack>
                <Stack
                  gap={1}
                  justifyContent={'center'}
                  alignItems={'center'}
                  sx={{ border: 1, borderRadius: 2, width: '40%' }}
                >
                  <Typography variant="h5" sx={{ mb: 1 }}>
                    Metas Por Quantidade
                  </Typography>
                  <Stack gap={1} justifyContent={'center'} alignItems={'center'} mb={2}>
                    {Array.from({ length: 12 }, (_, index) => (
                      <TextField
                        key={index}
                        size="small"
                        id={`meta-${index}`}
                        label={`Mês ${index + 1}`}
                        inputProps={{ type: 'number' }}
                        variant="outlined"
                        value={metas?.quantidade && metas.quantidade[index] ? metas.quantidade[index] : ''}
                        onChange={(e) => handleChangeMeta2(e, index)}
                      />
                    ))}
                  </Stack>
                </Stack>
              </Stack>
            )}
          </>
        )}
        {tipoMeta === 'unidade' && (
          <>
            <Stack direction={'row'} gap={3} justifyContent={'center'}>
              <Autocomplete
                disablePortal
                id="unidade"
                value={filtro.unidade}
                onChange={(event, newValue) => {
                  setFiltro({ ...filtro, unidade: newValue });
                }}
                options={unidades}
                isOptionEqualToValue={(option, value) => option._id === value._id}
                getOptionLabel={(option) => `${option.nome}`}
                sx={{ width: 400, mb: 2 }}
                renderInput={(params) => <TextField {...params} label="Selecione a Unidade" />}
              />
              <Button
                disabled={!alteracao}
                variant="contained"
                color="success"
                onClick={handleConfirmUnidade}
                sx={{ height: 50 }}
              >
                Salvar
              </Button>
            </Stack>
            <Stack>
              {filtro.unidade && (
                <Stack direction={'row'} justifyContent={'center'} gap={10}>
                  <Stack
                    gap={1}
                    justifyContent={'center'}
                    alignItems={'center'}
                    sx={{ border: 1, borderRadius: 2, width: '40%' }}
                  >
                    <Typography variant="h5" sx={{ mb: 1 }}>
                      Metas de Vendas
                    </Typography>
                    <Stack gap={1} justifyContent={'center'} alignItems={'center'} mb={2}>
                      {Array.from({ length: 12 }, (_, index) => (
                        <TextField
                          key={index}
                          size="small"
                          id={`meta-${index}`}
                          label={`Mês ${index + 1}`}
                          inputProps={{ type: 'number' }}
                          variant="outlined"
                          value={
                            metasUnidade?.metasVenda && metasUnidade.metasVenda[index]
                              ? metasUnidade.metasVenda[index]
                              : ''
                          }
                          onChange={(e) => handleChangeMetaUnidade(e, index, 'metasVenda')}
                        />
                      ))}
                    </Stack>
                  </Stack>
                  <Stack
                    gap={1}
                    justifyContent={'center'}
                    alignItems={'center'}
                    sx={{ border: 1, borderRadius: 2, width: '40%' }}
                  >
                    <Typography variant="h5" sx={{ mb: 1 }}>
                      Metas de Recebimentos
                    </Typography>
                    <Stack gap={1} justifyContent={'center'} alignItems={'center'} mb={2}>
                      {Array.from({ length: 12 }, (_, index) => (
                        <TextField
                          key={index}
                          size="small"
                          id={`meta-${index}`}
                          label={`Mês ${index + 1}`}
                          inputProps={{ type: 'number' }}
                          variant="outlined"
                          value={
                            metasUnidade?.metasRecebimento && metasUnidade.metasRecebimento[index]
                              ? metasUnidade.metasRecebimento[index]
                              : ''
                          }
                          onChange={(e) => handleChangeMetaUnidade(e, index, 'metasRecebimento')}
                        />
                      ))}
                    </Stack>
                  </Stack>
                </Stack>
              )}
            </Stack>
          </>
        )}
      </Container>
    </>
  );
}